import { on } from '@ngrx/store';

import {
  ManageSurveyActions,
  ManageSurveyApiActions,
} from './manage-survey.actions';
import { ManageSurveyState } from './manage-survey.model';

export const RECONCILIATION_HANDLERS = [
  on(
    ManageSurveyActions.loadReconciliationAttempts,
    (state): ManageSurveyState => ({
      ...state,
      reconciliationAttemptsLoading: true,
      reconciliationAttemptsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadReconciliationAttemptsSuccess,
    (state, { reconciliationAttempts }): ManageSurveyState => ({
      ...state,
      reconciliationAttempts,
      reconciliationAttemptsLoading: false,
      reconciliationAttemptsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadReconciliationAttemptsFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      reconciliationAttempts: [],
      reconciliationAttemptsLoading: false,
      reconciliationAttemptsError: error,
    }),
  ),

  on(
    ManageSurveyActions.uploadReconciliationFile,
    (state, { requestId }): ManageSurveyState => ({
      ...state,
      reconciliationUpload: null,
      reconciliationUploading: true,
      reconciliationUploadRequestId: requestId,
      reconciliationUploadError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.uploadReconciliationFileSuccess,
    (state, { reconciliationUpload }): ManageSurveyState => ({
      ...state,
      reconciliationUpload,
      reconciliationUploading: false,
      reconciliationUploadRequestId: null,
      reconciliationUploadError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.uploadReconciliationFileFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      reconciliationUpload: null,
      reconciliationUploading: false,
      reconciliationUploadRequestId: null,
      reconciliationUploadError: error,
    }),
  ),

  // Nobody is waiting for the in-flight upload any more; the upload effect
  // sees the cleared flag and discards the response instead of storing it.
  on(
    ManageSurveyActions.abandonReconciliationUpload,
    (state): ManageSurveyState => ({
      ...state,
      reconciliationUploading: false,
      reconciliationUploadRequestId: null,
    }),
  ),

  // The confirmation drawer has already closed when either command fires, so
  // the pending upload is cleared up front regardless of the API outcome.
  on(
    ManageSurveyActions.confirmReconciliation,
    ManageSurveyActions.declineReconciliation,
    (state): ManageSurveyState => ({
      ...state,
      reconciliationUpload: null,
      reconciliationUploading: false,
      reconciliationUploadRequestId: null,
      reconciliationUploadError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.confirmReconciliationFailure,
    ManageSurveyApiActions.declineReconciliationFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      reconciliationUpload: null,
      reconciliationUploading: false,
      reconciliationUploadRequestId: null,
      reconciliationUploadError: error,
    }),
  ),
];
